<template>
  <div class="wrap">
    <v-card-title style="margin-left: 20px; margin-top: 40px">
      <h4 style="margin-top: 10px">Plan Report</h4>
    </v-card-title>
    <div class="row">
      <v-flex xs6>
        <v-text-field
          style="margin-left: 30px"
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-flex>
      <div class="full-right" style="margin-left: 300px">
        <div class="d-flex justify-content-end">
          <v-btn color="primary" href="#/planmaster" align:right
            >Create Plan</v-btn
          >
          <v-btn
            color="primary"
            href="#/Planchannelmapping"
            align:right
            style="margin-left: 50px"
          >
            Plan And Channel Mapping</v-btn
          >
        </div>
      </div>
    </div>
    <div style="margin: 10px">
      <v-data-table
        :headers="columns"
        :items="planmasters"
        :loading="loading"
        :search="search"
      >
        <template v-slot:top>
          <v-dialog v-model="dialog" max-width="1000px">
            <v-card>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.identity.planCode"
                        label="Plan Code"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.planName"
                        label="Plan Name"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.category"
                        label="Plan Category"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.channelCount"
                        label="Channel Count"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.packageCode"
                        label="Package Code"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.serviceCode1"
                        label="Service Code"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.tariff"
                        label="Tariff"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.imageUrl"
                        label="Image Url"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field
                        v-model="editedItem.identity.region"
                        label="Region"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>

        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)"> edit </v-icon>
          <v-icon small @click="deleteItem(item)"> delete </v-icon>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { planmaster } from "@/services/planmaster";

export default {
  data() {
    return {
      search: "",
      dialog: false,
      loading: true,
      columns: [
        {
          text: "Plan Code",
          value: "identity.planCode",
        },
        {
          text: "Plan Name",
          value: "planName",
        },
        {
          text: "Plan Type",
          value: "planType",
        },
        {
          text: "Plan Category",
          value: "category",
        },
        {
          text: "Channel Count",
          value: "channelCount",
        },
        {
          text: "Package Code",
          value: "packageCode",
        },
        {
          text: "Service Code",
          value: "serviceCode",
        },
        {
          text: "Tariff",
          value: "tariff",
        },
        {
          text: "Image Url",
          value: "imageUrl",
        },
        {
          text: "Region",
          value: "identity.region",
        },
        {
          text: "Actions",
          value: "action",
        },
      ],

      planmasters: [],

      editedIndex: -1,
      editedItem: {
        identity: {
          planCode: "",
          region: "",
        },
        planName: 0,
        planType: 0,
        category: 0,
        channelCount: 0,
        packageCode: 0,
        serviceCode: 0,
        tariff: 0,
        imageUrl: 0,
      },
      defaultItem: {
        identity: {
          planCode: "",
          region: "",
        },
        planName: 0,
        planType: 0,
        category: 0,
        channelCount: 0,
        packageCode: 0,
        serviceCode: 0,
        tariff: 0,
        imageUrl: 0,
      },

      watch: {
        dialog(val) {
          val || this.close();
        },
      },
    };
  },
  methods: {
    async demo() {
      axios
        .get(
          "https://test.bripl.in/v1/api/customer/plan/channel-package?page=0"
        )
        .then((response) => {
          // this.planmasters = response.data;
          response.data.map((obj) => {
            let arrayObj = {
              serviceCode1: obj.serviceCode.slice(0, -2).slice(2),
              ...obj,
            };
            this.planmasters.push(arrayObj);
          });
        })
        .catch((error) => {
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },

    editItem(item) {
      this.editedIndex = this.planmasters.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      const index = this.planmasters.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.planmasters.splice(index, 1);

      axios
        .post("https://test.bripl.in/v1/api/planmaster/deleteByIdentity", {
          plancode: item.identity.planCode,
          region: item.identity.region,
        })
        .then((response) => {
          console.log(response);
        });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      // this.editedItem.serviceCode = [this.editedItem.serviceCode];

      if (this.editedIndex > -1) {
        axios.post(
          "https://test.bripl.in/v1/api/planmaster/createOrUpdate",
          {
            identity: {
              planCode: this.editedItem.identity.planCode,
              region: this.editedItem.identity.region,
            },
            planName: this.editedItem.planName,
            planType: this.editedItem.planType,
            category: this.editedItem.category,
            channelCount: this.editedItem.channelCount,
            packageCode: this.editedItem.packageCode,
            serviceCode: '["' + this.editedItem.serviceCode1 + '"]',
            imageUrl: this.editedItem.imageUrl,
          }
        );

        Object.assign(this.planmasters[this.editedIndex], this.editedItem);
      } else {
        axios
          .post("/planmaster", {
            identify: {
              planCode: this.editedItem.identity.planCode,
              region: this.editedItem.identity.region,
            },
            planName: this.editedItem.planName,
            planType: this.editedItem.planType,
            category: this.editedItem.category,
            channelCount: this.editedItem.channelCount,
            packageCode: this.editedItem.packageCode,
            serviceCode: this.editedItem.serviceCode,
            tariff: this.editedItem.tariff,
            imageUrl: this.editedItem.imageUrl,
          })
          .then((response) => {
            console.log(response);
          });

        this.planmasters.push(editedItem);
      }
      this.close();
    },
  },
  async mounted() {
    this.demo();
  },
};
</script>
<style>
.title {
  margin-right: 1400px;
}
.wrap {
  margin-top: -30px;
}
</style>
